import React from 'react'
import './searchbar.css'

function Searchbar({term}) {
    return (
        <div className="searchbar">
            <i className="fas fa-search"></i>
            <input type="text" id="search" className="search-input" onChange={term} />
        </div>
    )
}

export default Searchbar
